export const useClipboard = () => {

  const getTextFromClipboard = () => new Promise((resolve, reject)=>{
    if (navigator?.clipboard?.readText) {
      navigator.clipboard.readText()
        .then(text => {
          if (typeof text === "string" && text.length > 0) {
            resolve(text);
            return;
          }
          const manualText = window.prompt("No se pudo leer el portapapeles automáticamente. Pegá acá el código copiado.", "");
          if (manualText) {
            resolve(manualText);
          } else {
            reject("clipboard vacío o sin permisos");
          }
        })
        .catch(() => {
          const manualText = window.prompt("El navegador no pudo leer el portapapeles. Pegá acá el código copiado.", "");
          if (manualText) {
            resolve(manualText);
          } else {
            reject("no se pudo leer el clipboard");
          }
        });
      return;
    }

    const text = window.prompt("El explorador no soporta clipboard seguro. Pegá acá el código copiado.", "");
    if(text){
      resolve(text);
    }else{
      reject();
    }
  })

  const copyTextToClipboard = (text) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text)
      .catch((err) => {
        console.error('No se pudo escribir contenido en el clipboard: ', err);
        fallbackCopyTextToClipboard(text);
      });
      return;
    }
    fallbackCopyTextToClipboard(text);
  }

  const fallbackCopyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      //console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
  }

  return { getTextFromClipboard, copyTextToClipboard };
}
